import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_TITLE = 'TeleSpot';
const PLACEHOLDER = /{{(.+?)}}/g;

/**
 * Routes across the workspace declare their title in `data.title`, which Angular's default
 * strategy ignores, and interpolate resolved route data into it: `Workspace: {{workspace.name}}`.
 */
@Injectable({ providedIn: 'root' })
export class RouteDataTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const data = this.deepestRouteData(snapshot);
    const title = this.interpolate(data['title'] as string, data);

    this.title.setTitle(title || APP_TITLE);
  }

  private deepestRouteData(snapshot: RouterStateSnapshot): { [key: string]: unknown } {
    let route = snapshot.root;
    let data: { [key: string]: unknown } = { ...route.data };

    while (route.firstChild) {
      route = route.firstChild;
      data = { ...data, ...route.data };
    }
    return data;
  }

  private interpolate(title: string, data: { [key: string]: unknown }): string {
    if (!title) return '';

    return title
      .replace(PLACEHOLDER, (_, path: string) => String(this.resolvePath(path, data) ?? ''))
      .trim()
      .replace(/:$/, '');
  }

  private resolvePath(path: string, data: { [key: string]: unknown }): unknown {
    return path.split('.').reduce<unknown>((value, key) => (value as { [key: string]: unknown })?.[key], data);
  }
}
